// extracted by mini-css-extract-plugin
export default {"PageTitle":"_yFE_Ap1"};